import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import type { SavedContact } from "@freightsimple/generated-dashboard-openapi-client/models/SavedContact";
import { useState } from "react";
import ContactsLargeContactInput from "../Inputs/ContactsLargeContactInput";
import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import {
  EmailRequired,
  contactsErrorMessagesForContact,
} from "../Validators/contactsErrorMessagesForContact";

interface ContactsModifyContactDialogProps extends DialogBaseProps {
  contactToModify: SavedContact;
  /** Fired with the modified contact; the caller persists it. */
  onModified: (modifiedContact: SavedContact) => void;
}

// "Modify contact" form in a dialog. Stacks on top of the manage-contacts
// dialog. Replaces the legacy imperative modal.
export function ContactsModifyContactDialog(
  props: ContactsModifyContactDialogProps,
) {
  const [contact, setContact] = useState<SavedContact>(props.contactToModify);
  const [forceValidation, setForceValidation] = useState(false);

  const errorMessages = contactsErrorMessagesForContact(
    contact.contact,
    EmailRequired.EmailNotRequired,
  );

  const isValid =
    !errorMessages.contactName &&
    !errorMessages.emailAddress &&
    !errorMessages.phoneNumber;

  function onSave() {
    if (!isValid) {
      setForceValidation(true);
      return;
    }

    props.onModified(contact);
  }

  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Modify contact"
      width="narrow"
      footer={
        <>
          <Button onClick={() => props.onOpenChange?.(false)}>Cancel</Button>
          <Button primary onClick={onSave}>
            Save
          </Button>
        </>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        <ContactsLargeContactInput
          contact={contact.contact}
          contactChanged={function (updatedContact: AddContactContactType) {
            setContact({
              ...contact,
              contact: {
                ...contact.contact,
                ...updatedContact,
              },
            });
          }}
          forceValidation={forceValidation}
          errorMessages={errorMessages}
        />
      </ControlPresentationProvider>
    </Dialog>
  );
}
